import React from 'react';
import { Modal, Form } from 'react-bootstrap';

// Services & Helpers
import GlobalStateService from 'services/GlobalStateService';
import NotesTable from './NotesTable';

//-------------------------------------------------------------------------------------------------------------------

class AllNotesModal extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            isOpen: false
        };
    }

    show(opts) {
        return new Promise((resolve, reject) => {
            this.opts = opts;
            this.resolve = resolve;
            this.loginInfo = GlobalStateService.getValue('loginInfo');

            this.setState({
                isOpen: true
            });
        });
    }

    close() {
        this.setState({
            isOpen: false
        });
        this.resolve();
    }
        
    render() {
        const {
            isOpen
        } = this.state;

        if (!isOpen) {
            return null;
        }

        return (
            <Modal show className="all-notes-modal">
                <Modal.Body>

                    <NotesTable
                        {...this.props}
                        allowShowAll={false}
                        maxNum={null}
                    />

                </Modal.Body>
                <Modal.Footer>
                    <button type="button" className="btn btn-secondary me-auto" onClick={() => this.close()}>
                        Close
                    </button>
                </Modal.Footer>
            </Modal>
        );
    }
}

export default AllNotesModal;